import React, { useEffect, useState } from 'react';
import { Box, styled, keyframes } from '@mui/system';
import { Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { ROTATING_THINKING_MESSAGES } from '../constants';

const pulse = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const ThinkingWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '48px 24px',
  borderRadius: '16px',
  backgroundColor: '#faf5ff',
  border: '1px solid #f3e8ff',
  boxShadow: '0 4px 12px rgba(124, 58, 237, 0.03)',
  gap: '16px',
  width: '100%',
  boxSizing: 'border-box',
});

const GlowBar = styled(Box)({
  width: '180px',
  height: '4px',
  borderRadius: '2px',
  background: 'linear-gradient(90deg, #7c3aed, #c084fc, #3b82f6, #60a5fa, #7c3aed)',
  backgroundSize: '200% auto',
  animation: `${shimmer} 2s linear infinite`,
});

export default function AIThinking() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // Fade out
      setFade(false);

      setTimeout(() => {
        // Change text and fade in
        setIndex(prev => (prev + 1) % ROTATING_THINKING_MESSAGES.length);
        setFade(true);
      }, 150); // Small delay to let text hide
    }, 600); // Rotate message index every 600ms

    return () => clearInterval(interval);
  }, []);

  return (
    <ThinkingWrapper>
      <AutoAwesomeIcon
        sx={{
          fontSize: '28px',
          color: '#7c3aed',
          animation: `${pulse} 1.5s ease-in-out infinite`,
        }}
      />
      <Typography
        variant="body1"
        sx={{
          color: '#5b21b6',
          fontWeight: 600,
          fontSize: '15px',
          height: '24px',
          textAlign: 'center',
          opacity: fade ? 1 : 0,
          transform: fade ? 'translateY(0)' : 'translateY(2px)',
          transition: 'all 0.15s ease-in-out',
        }}
      >
        {ROTATING_THINKING_MESSAGES[index]}
      </Typography>
      <GlowBar />
    </ThinkingWrapper>
  );
}
